/**
 * The link under a Messages bubble that carries a reading.
 *
 * A care package is never public: its link must carry the recipient's invite
 * (the thread payload hands it to the recipient only) so it lands on the
 * care-package landing, sender's words, whole reading, close and the door.
 * Anything else links to the reading as before.
 */
export function messageReadingLink(m) {
  if (!m || !m.reading_short_uuid) return null
  const base = `/?reading=${encodeURIComponent(m.reading_short_uuid)}`
  if (m.is_gift && m.invite) {
    return {
      href: `${base}&inv=${encodeURIComponent(m.invite)}`,
      label: `A care package from ${m.from_name || 'someone who cares about you'}`,
      icon: 'fa-gift',
    }
  }
  return { href: base, label: m.reading_title || 'A shared reading', icon: 'fa-scroll' }
}
